let server = process.env.REACT_APP_API_URL;

let frontendRoute = process.env.REACT_APP_FRONTEND_URL;

let productionMode = (process.env.REACT_APP_NODE_ENV === "production"); // valorizzare in TRUE per produzione
let versionApp = process.env.REACT_APP_VERSION; //Valorizzare per cambiare versione applicazione
let emailAssistance = process.env.REACT_APP_API_EMAIL_ASSISTANCE; //email assistenza
let route = {
  test: '/test',

  // dashboard
  dashboard: '/dashboard',
  dashboardCounters: "/dashboard/counters",
  dashboardConsulents: "/dashboard/consulents",
  dashboardConsulent: "/dashboard/consulent",
  dashboardModules: "/dashboard/modules",

  // geo service
  autocompleteGeo: '/geo/autocomplete',
  detailGeo: '/geo/detail',
  geoGps: '/geo/gps',

  // auth
  checkToken: '/token/check',
  permission: '/auth/permission',
  login: '/auth/signin',
  // Gettone monouso per passare al portale nuovo senza rifare l'accesso (vedi passaggioPortale.js)
  authHandoff: '/auth/handoff',
  // Il verso opposto: le pagine embed (dentro ATOM) scambiano il gettone in ingresso con una sessione
  authHandoffExchange: '/auth/handoff/exchange',
  credentialEdit: '/auth/changepsw',
  resetPassword: '/auth/forgotpsw',
  completeResetPassword: '/auth/forgotpsw/reset',
  verifyOTP: '/auth/verifyotp',
  resendOTP: '/auth/verifyotp',
  changeSession: "/auth/changesession",
  logout: "/auth/logout",

  // admin
  admin: '/admin',

  // L'estrazione dei dati verso ATOM. Solo ADMIN: da qui esce l'anagrafica
  // completa dei corsisti, ed e' il dato piu' delicato che ci sia qui dentro.
  exportAtom: '/admin/export/atom',
  exportAtomConteggio: '/admin/export/atom/conteggio',

  // consulent
  consulent: '/consulent',

  // lead
  lead: '/lead',
  leadStatus: '/lead/status',
  leadQuestion: '/lead/question',
  leadClose: '/lead/close',
  leadlog: '/leadlog',
  reminder: '/lead/reminder',
  reminderConfirm: '/lead/reminder/confirm',
  leadUpload: '/lead/upload',
  leadAssign: '/lead/assign',
  leadAssignGroup: '/lead/group',
  leadMatch: '/lead/match',
  leadRemarketing: '/lead/remarketing',
  addTrial: '/lead/trial',

  // appointment
  appointment: '/appointment',

  // module
  module: '/module',
  moduleAssign: '/module/transfer',

  // teacher
  teacher: "/teacher",

  available: "/available",
  availableDash: "/available/dash",

  //report
  reporter: "/reporter",
  report: "/report",

  // network
  network: "/network",
  networker: "/networker",
  networkerTransfer: "/networker/transfer",
  networkerCreate: "/networker/create",
  networkerReport: "/networker/report",
  networkerReporter: "/networker/reporter",
  networkerPay: "/networker/pay",


  // user
  user: "/user",
  resendSignup: "/user/resendtoken",
  signup: "/user/signup",

  // client
  clientDisconnect: "/client/disconnect",
  client: "/client",
  clientQuestion: '/client/question',

  // referent
  referent: "/referent",

  // course
  course: "/course",
  courseAvailable: "/available/course",

  // sell
  sell: "/sell",

  // streaming
  streaming: "/streaming",
  streamingRequest: "/streaming/request",
  streamingView: "/streaming/view",

  lesson: '/lesson',
  file: '/file',
  level: '/level',

  // payment
  payment: '/payment',
  paymentCheck: '/payment/check',

  // classroom
  classRoom: '/classroom',
  classRoomAttendanceDetail: '/classroom/attendance',
  classRoomListClient: '/classroom/list',
  classRoomInside: '/classroom/inside',
  classRoomPost: '/classroom/post',
  classRoomPostFile: '/classroom/post/file',
  classRoomLesson: '/classroom/lesson',
  classRoomDateStart: '/classroom/start',
  classRoomDateEnd: '/classroom/end',
  classRoomPartecipants: '/classroom/partecipants',
  classroomWaiting: '/classroom/waiting',
  classroomPendingPayments: '/classroom/pending-payments',
  classroomDeploy: '/classroom/deploy',
  classroomComplete: '/classroom/complete',
  classroomAbandon: '/classroom/abandon',
  classroomRevert: '/classroom/revert',
  // [10/09/2026] Riapre una classe chiusa per sbaglio: COMPLETED -> ACTIVE, solo ADMIN, e solo
  // se la chiusura non ha lasciato voti (quindi nessun attestato emesso). Non e' l'inverso di
  // revert, che porta in bozza: e' la sola uscita da COMPLETED.
  classroomReopen: '/classroom/reopen',
  classroomInsert: '/classroom/insert',
  classroomRemove: '/classroom/remove',
  classroomConsulent: '/classroom/consulent',
  classroomEditClient: '/client/edit/classroom',

  // classroom individual
  classRoomIndividual: '/classroom/individual',
  classRoomIndividualLesson: '/classroom/individual/lesson',
  classRoomIndividualAttendance: '/classroom/individual/attendance',
  classRoomIndividualPost: '/classroom/individual/post',
  classRoomIndividualPostFile: "/classroom/individual/post/file",
  classRoomBoardSeen: '/classroom/{id}/board/seen',
  classRoomIndividualBoardSeen: '/classroom/individual/{id}/board/seen',
  classRoomIndividualComplete: '/classroom/individual/complete',
  classRoomIndividualAbandon: '/classroom/individual/abandon',



  // group
  group: '/group',
  groupSell: '/group/insert/sell',
  groupWaiting: '/group/insert/waiting',
  groupAvailable: '/group/available',

  classroomTrial: '/classroomtrial',
  classroomTrialInsert: '/classroomtrial/insert',
  classroomTrialStart: '/classroomtrial/start',
  classroomTrialLink: '/classroomtrial/link',
  classroomTrialSign: '/classroomtrial/sign',

  // certificates
  clientCertificates: '/client/{id}/certificates',
  myCertificates: '/my/certificates',
  certificateDownload: '/certificate/{id}/download',
  certificateRegenerate: '/certificate/{id}/regenerate',
  certificateResend: '/certificate/{id}/resend',

  // lezioni live — l'abbonamento del singolo cliente, dalla sua scheda
  // I nomi dei piani NON stanno qui: li da' il server leggendo `atom_product_map`, la
  // stessa mappa che usa il ponte verso ATOM. Scriverli qui sarebbe una seconda verita'.
  livePlans: '/live/plans',
  liveSubscription: '/live/subscription',
  liveSubscriptionClient: '/live/subscription/{id}',

  // i videocorsi aperti a un corsista dal piano SMART. NON sono vendite: non entrano nel
  // fatturato ne' nelle statistiche. Vedi course_entitlements sul backend.
  clientCourses: '/client/{id}/courses',
  clientCourse: '/client/{id}/courses/{idCourse}',

  // notifications
  notification: '/notification',
  notificationRead: '/notification/read',
  notificationReadAll: '/notification/read-all',

  // statistics
  statisticsLeads: '/statistics/leads',
  statisticsSells: '/statistics/sells',
  statisticsPayments: '/statistics/payments'
};



for (var i in route) {
  route[i] = server + route[i];
}
global.server = server;
global.frontend = frontendRoute;
global.productionMode = productionMode;
global.versionApp = versionApp;
global.emailAssistance = emailAssistance;
global.route = route;
module.export = route;
